import React from 'react';
import { motion } from 'framer-motion';
interface LogoProps {
  className?: string;
  variant?: 'default' | 'white';
}
export function Logo({
  className = '',
  variant = 'default'
}: LogoProps) {
  const textColor = variant === 'white' ? 'text-white' : 'text-slate-900';
  const iconColor = variant === 'white' ? '#FFFFFF' : '#0D9488'; // Teal-600
  const accentColor = variant === 'white' ? '#E2E8F0' : '#F97316'; // Orange-500
  return <div className={`flex items-center gap-2 font-bold text-xl tracking-tight ${textColor} ${className}`} data-id="element-238">
      <motion.svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" initial={{
      rotate: -10
    }} animate={{
      rotate: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-239">
        <rect x="4" y="4" width="14" height="14" rx="2" fill={iconColor} fillOpacity="0.9" data-id="element-240" />
        <rect x="14" y="14" width="14" height="14" rx="2" fill={accentColor} fillOpacity="0.9" data-id="element-241" />
        <path d="M11 11H21V21H11V11Z" fill="white" fillOpacity="0.2" data-id="element-242" />
      </motion.svg>
      <span data-id="element-243">HomeLinkPro</span>
    </div>;
}